import $ from 'jquery';
// import bootstrap from "bootstrap"
// import "bootstrap"

window.bootstrap = require('../../../node_modules/bootstrap/js/index.esm');

$(document).ready(function () {
    var o = 20
        , i = o / $(document).height()
        , n = o / $(document).width();
    $("body").on("mousemove", function (a) {
        var t = a.pageX - $(document).width() / 2
            , o = a.pageY - $(document).height() / 2
            , s = n * t * -1
            , m = i * o * -1
            , c = $(".lm-animated-bg");
        c.addClass("transition")
        c.css({
            "background-position": "calc( 50% + " + s + "px ) calc( 50% + " + m + "px )"
        })
        setTimeout(function () {
            c.removeClass("transition")
        }, 300)
    })
});

/** start tooltip ***/
// $(document).ready(function () {
//     var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
//     var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
//         return new bootstrap.Tooltip(tooltipTriggerEl)
//     })
// });


/**black-menu***/
$(document).ready(function () {
    var oldTop = 0;
    var flag_menu = 0;
    $(".menu-page-in").hover(
        function () {
            $(".black-menu").show();
        },
        function () {
            $(".black-menu").hide();
        }
    );
});
/**** end black-menu ****/












